<template>
  <div class="verification">
    <div class="acc-page-holder">
      <div v-if="brandTemplate!== 'generic_2' && mobileBigAndBelow && showMap && accountSummaryFlow" class="account-heading"><icon name="icon-acc-verification"></icon>{{ $t('MyAccount.FirstTimeLogin.Title') }}</div>
      <h1 class="ver_status" v-if="brandTemplate=== 'generic_2'"> {{ $t('Account.Verification.Status.Title') }} </h1>
      <div class="verification-content">
        <div v-if="!isCustomerVerified">
          <div v-if="showMap">
            <div class="blue-heading" v-html="$t('Account.SequentialVerification.GuidedVerification.Title')"></div>
            <div class="padding-separate">
              <VerTitles :currStepTitle="$t('Account.SequentialVerification.VerificationMaps.Title')" :isMapPage="false" @closePage="closeVerPage"></VerTitles>
              <div v-if="verMaps && verMaps.length > 0">
                <div v-if="verMaps && verMaps.length > 1" class="verification_map_desc">
                  <p v-html="$t('Account.SequentialVerification.VerificationMaps.Desc')"></p>
                </div>
                <div v-if="verMaps && verMaps.length ===1 && verMaps[0].idtxregpage === 'VERIFY_SLF' && onPremiseVerification">
                  <p v-html="$t('Account.SequentialVerification.VerificationMaps.In.Casino.Desc')"></p>
                  <p v-html="$t('Account.SequentialVerification.VerificationMaps.In.Casino.Desc2')"></p>
                  <p v-html="$t('Account.SequentialVerification.VerificationMaps.In.Casino.Desc3')" class="color-red font-600"></p>
                  <p v-html="$t('Account.SequentialVerification.VerificationMaps.In.Casino.Desc4')"></p>
                  <p v-html="$t('Account.SequentialVerification.VerificationMaps.In.Casino.Desc5')"></p>
                </div>
                <div v-for="vM in verMaps" :key="vM.mapno">
                  <div class="verification__instruments">
                    <!-- Maps -->
                    <div :class="[{ 'action-disabled': (verMaps[0].regpagestate === 'SENT' || disableOnPremiseGeolocationButton || !isGeolocatedInState) && verMaps && verMaps.length ===1 && verMaps[0].idtxregpage === 'VERIFY_SLF'},
                    {'geoInProgessOrSuccess': (mgProgress.inProgress && !mgProgress.postContentFailed) || (!mgProgress.inProgress && mgProgress.postContentSuccess)},
                    {'geoFailed': !mgProgress.inProgress && mgProgress.postContentFailed},
                    {'location-verified': mgProgress.postContentSuccess} ]"
                         class="verification__instruments_item diss" @click.stop="go2Verification(vM.mapno, vM.idtxregpage, vM.regpagestate)">
                    <span class="piitem-text">
                      <template v-if="verMaps && verMaps.length === 1 && verMaps[0].idtxregpage === 'VERIFY_SLF'">
                        <div v-if="!mobileGeolocationOnPremiseInProgress || (mobileGeolocationOnPremiseInProgress && !mobileGeolocationOnPremiseInProgress.display)" class="piitem-text-desc">{{ verMaps[0].regpagestate === 'SENT' ? $t('Account.Verification.In.Casino.Map.Sent.Title') : $t('Account.Verification.In.Casino.Map.Title') }}
                        <span class="piitem-arrow"><v-icon>chevron_right</v-icon></span></div>
                        <mobile-geolocation-on-premise-dialog v-if="isMobileApp && isLoggedIn && (mobileGeolocationOnPremiseInProgress && mobileGeolocationOnPremiseInProgress.display)" :mapno="vM.mapno" :idtxregpage="vM.idtxregpage" :regpagestate="vM.regpagestate" @startVerificationFromCasino="go2Verification"></mobile-geolocation-on-premise-dialog>
                      </template>
                      <template v-else>
                        <div class="piitem-text-headline">{{vM.title}}</div>
                        <div class="vm_shortdesc piitem-text-desc">{{vM.shortdescription}}</div>
                        <div class="piitem-text-desc">{{vM.mapdescription}}</div>
                      </template>
                       <span v-if="verMaps && verMaps.length ===1 && verMaps[0].idtxregpage !== 'VERIFY_SLF'" class="piitem-arrow"><v-icon>chevron_right</v-icon></span>
                    </span>
                    </div>
                    <p v-if="vM.idtxregpage === 'VERIFY_SLF' && !isGeolocatedInState && showNotLocatedInStateMessage">{{ $t('nativeApp.failedGeolocation.contect.' + state) }}</p>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="verification_map_desc">
                  <p>{{$t('Account.SequentialVerification.VerificationMaps.NoMaps')}}</p>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <Verification @closePage="closeVerPage"></Verification>
          </div>
        </div>
        <div v-else>
          <div v-if="brandTemplate ==='generic_2'" class="blue-heading" v-html="$t('Account.SequentialVerification.GuidedVerification.Title')"></div>
          <div class="padding-separate verified_customer">
            <div v-if="isEmailVerified && brandTemplate ==='generic_2'" class="badge_verified">
              <p>{{ $t('Account.SequentialVerification.VerifyByPin.Verification.Detail.Status.Verified') }}</p>
              <span class="icon-verified"></span>
            </div>
            <VerTitles :currStepTitle="$t('Account.Verification.Status.Title')" :isMapPage="false"></VerTitles>
            <div class="verification_map_desc">
              <p class="span_bold" v-html="$t('Account.Verification.Status.Desc')"></p>
              <p v-if="brandKey === 'sb'" v-html="$t('Account.Verification.Status.Superbook')"></p>
              <p v-if="brandKey !== 'sb' && state !== 'NV'" v-html="$t('Account.Verification.Status.PlaySportsbook')"></p>
              <p @click="home()" v-if="brandKey !== 'sb' && state === 'NV'" v-html="$t('Account.Verification.Status.In.Casino.PlaySportsbook')"></p>
              <p v-if="(brandTemplate ==='generic_2' && state !== 'NV') && (!isEmailVerified || !isPhoneVerified)" v-html="$t('Account.Verification.Status.Rilot')"></p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showMap">
        <verify-detail detail="phone"></verify-detail>
        <verify-detail detail="email"></verify-detail>
      </div>
    </div>
    <div v-if="brandTemplate === 'generic_2'" class="acc_page_bgr_img"><icon name="icon-acc-verification"></icon></div>
  </div>

</template>

<script>
  import store from '@/store'
  import Screen from '@/components/mixins/Screen'
  import Branding from '@/components/mixins/Branding'
  import accounting from '@/components/mixins/accounting'
  import VerTitles from '@/components/account/Verification/VerTitles'
  import Verification from '@/components/account/Verification/Verification.vue'
  import VerifyDetail from '@/components/account/Verification/VerifyDetail.vue'
  import Icon from '@/components/common/Icon'
  import mobileBridge from '@/library/mobileBridge'
  import config from '@/config'
  import GeolocationLoader from '@/components/common/GeolocationLoader.vue'
  import mobileGeolocationOnPremiseDialog from '@/components/layout/parts/mobileGeolocationOnPremiseDialog'
  import scrollToTop from '@/library/scrollToTop.js'

  // let promiseResolve, promiseReject

  export default {
    name: 'VerificationMaps',
    mixins: [Screen, Branding, accounting],
    components: {
      VerTitles,
      Verification,
      VerifyDetail,
      Icon,
      GeolocationLoader,
      mobileGeolocationOnPremiseDialog
    },
    data () {
      return {
        showMap: true,
        showNotLocatedInStateMessage: false,
        onPremiseInProgress: false,
        preventClicking: false,
        promise: false,
        pausePromise: true,
        promiseCallback: false
      }
    },
    computed: {
      verMaps () {
        return store.getters['verification/getVerificationMaps']
      },
      isCustomerVerified () {
        return store.getters['getIsCustomerVerified']
      },
      accountSummaryFlow () {
        return window.ctsautoconf.ACCOUNT_SUMMARY_FLOW || false
      },
      isEmailVerified () {
        return store.getters['getIsEmailVerified']
      },
      isPhoneVerified () {
        return store.getters['getIsPhoneVerified']
      },
      isGeolocatedInState () {
        return store.getters['getGeolocated']
      },
      isMobileApp () {
        return config && config.app && config.app.autoconf && config.app.autoconf.MOBILE_LS
      },
      state () {
        return config.app.autoconf.STATE
      },
      mobileGeolocationOnPremiseInProgress () {
        return store.getters['getMobileGeolocationOnPremiseInProgress']
      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      isGeolocatedInCasino () {
        return store.getters['getOnPremiseGeolocated']
      },
      mgProgress () {
        return store.getters['getMobileGeolocationOnPremiseInProgress']
      },
      disableOnPremiseGeolocationButton () {
        return store.getters['getDisableOnPremiseGeolocationButton']
      },
      onPremiseVerification () {
        return config.app.autoconf.ON_PREMISE_VERIFICATION || false
      }
    },
    methods: {
      go2Verification (mapId, mapPage, mapState) {
        console.log('go 2 ver', mapState)
        if (mapId instanceof Object && mapId.dialog === 'emitFromGeoDialog') {
          mapState = mapId.regpagestate
          mapPage = mapId.idtxregpage
          mapId = mapId.mapno
          this.preventClicking = false
        }
        if (mapPage === 'VERIFY_SLF' && this.isMobileApp) {
          this.goToSelfieVerificationPage(mapId, mapState)
          return false
        }
        store.commit('verification/setMapId', mapId)
        localStorage.setItem('verificationMapId', mapId)
        this.scroll2Top()
        this.showMap = false
      },
      scroll2Top () {
        scrollToTop()
      },
      closeVerPage () {
        this.showMap = true
        this.resetAllStateForSelfieVerification()
      },
      asynchronousFunction (cb) {
        this.promiseCallback = cb
        if (this.pausePromise) return false
        setTimeout(function () {
          cb()
        }, 3000)
      },
      goToSelfieVerificationPage (mapId, mapState) {
        if (this.onPremiseInProgress || this.preventClicking || mapState === 'SENT') return false
        console.log('VER', mapState)
        if (!this.isGeolocatedInState) {
          this.showNotLocatedInStateMessage = true
          return false
        } else if (!this.disableOnPremiseGeolocationButton && this.isGeolocatedInState && mapState === 'INITIAL') {
          this.preventClicking = true
          mobileBridge.bridgeSendRequest('onPremiseVerificationStart')
          let self = this
          self.promise = new Promise(function (resolve, reject) {
            self.asynchronousFunction(() => {
              resolve()
            })
          }).then(function () {
            if (self.isMobileApp) {
              store.commit('verification/setMapId', mapId)
              localStorage.setItem('verificationMapId', mapId)
              self.scroll2Top()
              self.showMap = false
              self.promise = false
              self.pausePromise = true
              self.preventClicking = false
            }
          })
          return false
        } else if (this.isGeolocatedInState && (mapState === 'SENT' || mapState === 'REJECTED')) {
          store.commit('verification/setMapId', mapId)
          localStorage.setItem('verificationMapId', mapId)
          this.scroll2Top()
          this.showMap = false
        }
        this.showNotLocatedInStateMessage = false
      },
      resetAllStateForSelfieVerification () {
        this.showNotLocatedInStateMessage = false
        if (this.isMobileApp && (this.verMaps && this.verMaps.length === 1 && this.verMaps[0].idtxregpage === 'VERIFY_SLF') && this.verMaps[0].regpagestate === 'INITIAL') {
          mobileBridge.bridgeSendRequest('onPremiseVerificationEnd')
          this.promise = false
          this.promiseCallback = false
          this.preventClicking = false
          this.pausePromise = true
          this.onPremiseInProgress = false
          store.commit('setOnPremiseGeolocated', false)
          store.commit('setMobileGeolocationOnPremiseInProgress', false)
        }
      },
      home () {
        this.$router.push({name: 'sports'})
      }
    },
    mounted () {
      store.dispatch('verification/fetchVerificationMaps')
      store.dispatch('getCustomerContext')
    },
    destroyed () {
      localStorage.removeItem('verificationMapId')
      localStorage.removeItem('verificationMaps')
      this.resetAllStateForSelfieVerification()
    },
    watch: {
      isLoggedIn (newVal) {
        if (!newVal) {
          this.$router.push({name: 'sports'})
          store.commit('setMobileGeolocationOnPremiseInProgress', false)
        }
      },
      mobileGeolocationOnPremiseInProgress (newVal) {
        if (newVal && (newVal.display && newVal.inProgress)) {
          this.onPremiseInProgress = true
          this.preventClicking = true
          return false
        }
        if (newVal && (newVal.display && newVal.postContentFailed) && this.promise) {
          this.promise = null
        }
        this.onPremiseInProgress = false
      },
      isGeolocatedInCasino (newVal) {
        if (newVal) {
          this.pausePromise = false
          this.asynchronousFunction(this.promiseCallback)
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
@import "~@/css/config"
@import "~@/css/mixins"

.verification
  background white
  .blue-heading
    padding: 10px 20px
    background: #003764
    color: #fff
    font-size 16px
    font-family 'Open Sans SemiBold'
    @media mobile-big-and-below
      padding 10px
  .padding-separate
    padding 20px
    @media mobile-big-and-below
      padding 10px
  .ver-padding
    &.padding-0
      padding 0 15px
      >>>.v-expansion-panel__header
        padding 12px 0 !important
    @media mobile-big-and-below
      padding 0 15px
  .verification_map_desc
    background #e5e5e5
    border-radius 3px
    padding 10px
    margin 0
    font-size 14px
    p
      margin: 5px 0
    .strong_text
      font-family: "Open Sans Bold" !important
    @media mobile-big-and-below
      font-size 13px
      margin 0
  @media mobile-big-and-below
    padding 15px
  .verification__instruments
    margin 0
    padding 20px 0 0 0
    @media mobile-big-and-below
      margin 0
    .verification__instruments_item
      cursor pointer
      display block
      min-height 60px
      color var(--account-verification-start-btn-color)
      background var(--account-verification-start-btn-bgr)
      border-top 1px solid var(--account-verification-start-btn-border-color)
      border-left 1px solid var(--account-verification-start-btn-border-color)
      border-right 1px solid var(--account-verification-start-btn-border-color)
      padding 5px 0px 5px 15px
      border-radius 7px
      margin-bottom: 5px
      &:last-child
        border-bottom 1px solid var(--account-verification-start-btn-border-color)
      .piitem-picture,
      >>> .piitem-picture
        display flex
        flex 3
        justify-content center
        align-items center
        padding 0 5px
        img
          width 100%
          height auto
      .piitem-text,
      >>> .piitem-text
        flex 20
        display flex
        justify-content center
        flex-direction column
        .piitem-text-headline
          font-size 16px
          font-family: "Open Sans Bold"
          padding 5px
        .piitem-text-desc
          font-size 16px
          padding 5px
          display flex
          align-items center
      .piitem-arrow,
      >>> .piitem-arrow
        display flex
        flex 1
        justify-content center
        align-items center
        justify-content: right
        i
          font-size 40px
          color var(--account-verification-start-btn-color) !important
.badge_verified
  color #1d9add
  font-family: "Open Sans Bold"
  display: flex
  justify-content: flex-end
  p
    margin 0
  .icon-verified
    margin-left 5px
    display: inline-block
    background-image: url(icons-path'/'verified'.svg')
    height: 25px !important
    width: 22px !important

.action-disabled
  background-color #cfd6db !important
@media mobile-big-and-below
  .verification__instruments_item.verification__instruments_item.geoFailed
    border 1px solid #f00 !important
    padding-right 15px
  .verification__instruments_item.verification__instruments_item.location-verified
    border 1px solid #7ac142 !important
    padding-right 15px !important
  .verification__instruments_item.verification__instruments_item.geoInProgessOrSuccess
    padding-right 15px
.color-red
  color: var(--account-verification-accent-text-color)
  font-size 14px
</style>



// WEBPACK FOOTER //
// src/components/account/Verification/VerificationMaps.vue